const SOURCE_LABEL = {
  coupang: '쿠팡',
  naver: '네이버',
  '11st': '11번가',
  gmarket: '지마켓',
};

export default function ProductCard({ item, style }) {
  const sourceLabel = SOURCE_LABEL[item.source] || item.source;

  return (
    <a
      className="product-card"
      href={item.link || '#'}
      target="_blank"
      rel="noopener noreferrer"
      style={style}
    >
      <div className="product-card__thumb">
        {item.image ? (
          <img src={item.image} alt={item.name} loading="lazy" />
        ) : (
          <div className="product-card__noimg">이미지 없음</div>
        )}
        <span className="product-card__source-badge">{sourceLabel}</span>
        {item.isAd && <span className="product-card__ad-badge">AD</span>}
      </div>
      <div className="product-card__body">
        <div className="product-card__name">{item.name}</div>
        <div className="product-card__price-row">
          {item.discountRate && (
            <span className="product-card__discount">{item.discountRate}</span>
          )}
          <span className="product-card__price">
            {item.price ? item.price.toLocaleString('ko-KR') : '-'}
          </span>
          <span className="product-card__price-suffix">원</span>
        </div>
        <div className="product-card__meta">
          {item.rating && (
            <span className="product-card__rating">
              <span className="product-card__rating-star">★</span>
              {item.rating}
            </span>
          )}
          {item.reviewCount != null && (
            <span>리뷰 {item.reviewCount.toLocaleString('ko-KR')}</span>
          )}
        </div>
        {item.seller && (
          <div className="product-card__seller">{item.seller}</div>
        )}
      </div>
    </a>
  );
}
